export default __webpack_public_path__ + "static/media/cert.633b0112.png";